export interface UserModel {
    uid: string;
    email: string;
    displayName: string;
    forename: string;
    surname: string;
    joinDate: string;
}

export interface MediaBase {
    backdrop_path: string;
    id: number;
    media_type: string;
    overview: string;
    poster_path: string;
    release_date: string;
    vote_average: number;
    vote_count: number;
    watch_count?: number;
    watch_id?: string;
}

export interface MovieModel extends MediaBase {
    budget?: number;
    credits?: Credits;
    genres: GeneralResource[];
    imdb_id?: string;
    production_companies: GeneralResource[];
    release_date: string;
    revenue?: number;
    runtime: number;
    title: string;
    videos?: Videos;
    studios?: GeneralResource[];
    directors?: GeneralResource[];
    writers?: GeneralResource[];
    cast?: GeneralResource[];
}

export interface SeriesModel extends MediaBase {
    aggregate_credits?: Credits;
    created_by?: GeneralResource[];
    episode_count?: number;
    first_air_date: string;
    genres: GeneralResource[];
    images?: Images;
    last_air_date?: string;
    name: string;
    poster_path: string;
    seasons: SeasonModel[];
    status: string;
    videos?: Videos;
    cast: GeneralResource[];
    title: string;
}

export interface SeasonModel extends MediaBase {
    air_date: string;
    aggregate_credits?: Credits;
    episodes: EpisodeModel[];
    episode_count: number;
    name: string;
    season_number: number;
    videos?: Videos;
}

export interface EpisodeModel extends MediaBase {
    air_date: string;
    episode_number: number;
    name: string;
    runtime?: number;
    season_number: number;
    still_path?: string;

    credits?: Credits;
}

export interface PersonModel {
    biography: string;
    birthday: string;
    gender: Gender;
    id: number;
    job: string;
    known_for: string;
    known_for_department?: string;
    name: string;
    profile_path: string;
    place_of_birth: string;
    total_episode_count?: number;

    combined_credits: {
        cast: Array<{
            id: string;
            title?: string;
            name?: string;
            release_date?: string;
            first_air_date?: string;
            character?: string;
            poster_path?: string;
            media_type: string;
            job?: string;
        }>;
        crew: Array<{
            id: string;
            title?: string;
            name?: string;
            release_date?: string;
            first_air_date?: string;
            job?: string;
            poster_path?: string;
            media_type: string;
            department: string;
        }>;
    };
}

interface GeneralResource {
    id: number;
    name: string;
}

interface Videos {
    results: {
        key: string;
        type: string;
    }[];
}

interface Credits {
    cast: PersonModel[];
    crew: PersonModel[];
}

interface Images {
    posters: {
        file_path: string;
    }[];
}

export enum Gender {
    Unknown = 0,
    Female = 1,
    Male = 2,
    NonBinary = 3
}